import { components, ClearIndicatorProps } from 'react-select';
import { OptionType } from '..';

export default function CustomClearIndicator(props: ClearIndicatorProps<OptionType, true>) {
	return (
		<components.ClearIndicator
			{...props}
			innerProps={{
				...props.innerProps,
				onMouseDown: (e) => {
					console.log(e);
					e.preventDefault();
					e.stopPropagation();
					props.innerProps.onMouseDown?.(e);
				},
			}}
		/>
	);
}